import { useLang } from "../context/LanguageContext";
import { TID } from "../constants/testIds";

const langs = [
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "ta", label: "TA" },
];

const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center gap-1 text-xs" data-testid={TID.langSwitch}>
      {langs.map((l, i) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          className={`px-2 py-1 rounded transition-colors ${lang === l.code ? "text-primary" : "text-muted-foreground hover:text-foreground"}`}
          data-testid={`lang-${l.code}`}
        >
          {l.label}{i < langs.length - 1 ? "" : ""}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
